"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    completeFeud: function() {
        return completeFeud;
    },
    createFeud: function() {
        return createFeud;
    },
    deleteFeud: function() {
        return deleteFeud;
    },
    duplicateFeud: function() {
        return duplicateFeud;
    },
    feudNextStage: function() {
        return feudNextStage;
    },
    feudPreviousStage: function() {
        return feudPreviousStage;
    },
    generateFeuds: function() {
        return generateFeuds;
    },
    resetFeuds: function() {
        return resetFeuds;
    },
    resetStage: function() {
        return resetStage;
    },
    selectFeudWinnerWithBoost: function() {
        return selectFeudWinnerWithBoost;
    },
    updateFeud: function() {
        return updateFeud;
    }
});
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
const _wrestlers = require("./wrestlers");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createFeud(payload) {
    return {
        type: _types.ADD_FEUD,
        payload
    };
}
function duplicateFeud(payload) {
    return {
        type: _types.DUPLICATE_FEUD,
        payload
    };
}
function updateFeud(payload) {
    return {
        type: _types.UPDATE_FEUD,
        payload
    };
}
function deleteFeud(id) {
    return {
        type: _types.DELETE_FEUD,
        payload: id
    };
}
function resetFeuds() {
    return {
        type: _types.RESET_FEUDS
    };
}
function generateFeuds(payload) {
    return {
        type: _types.GENERATE_FEUDS,
        payload
    };
}
function completeFeud({ id }) {
    return {
        type: _types.COMPLETE_FEUD,
        payload: {
            id
        }
    };
}
function feudPreviousStage({ id }) {
    return {
        type: _types.PREVIOUS_STAGE,
        payload: {
            id
        }
    };
}
function selectFeudWinnerWithBoost(feud) {
    return (dispatch)=>{
        const randomWinner = ()=>Math.floor(Math.random() * feud.wrestlerIds.length);
        const winnerIds = [
            feud.wrestlerIds[randomWinner()]
        ];
        winnerIds.forEach((id)=>{
            dispatch((0, _wrestlers.boostWrestlers)({
                id
            }));
        });
    };
}
function feudNextStage({ id }) {
    return (dispatch, getState)=>{
        const state = getState();
        const { Feud } = state.entitiesv2;
        const item = Feud?.itemsById?.[id];
        if (item && !item.complete && Number(item.stageId) <= Number(item.maxStages)) {
            const stageId = item.stageId + 1;
            const complete = stageId === item.maxStages;
            if (complete) {
                dispatch(completeFeud({
                    id
                }));
                dispatch(selectFeudWinnerWithBoost(item));
            } else {
                dispatch(updateFeud({
                    ...item,
                    stageId
                }));
            }
        }
    };
}
function resetStage({ id }) {
    return {
        type: _types.RESET_STAGE,
        payload: {
            id
        }
    };
}
